module.exports = __webpack_public_path__ + "static/media/profile-cover.d0efa1ae.jpg";